import { render, staticRenderFns } from "./StaticIp.vue?vue&type=template&id=a1986eae&scoped=true&"
import script from "./StaticIp.vue?vue&type=script&lang=ts&"
export * from "./StaticIp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1986eae",
  null
  
)

export default component.exports